import { createSlice } from "@reduxjs/toolkit";
import {
  getAllAboutImages,
  getAboutImageById,
  createAboutImage,
  updateAboutImage,
  deleteAboutImage,
  reorderAboutImages,
} from "actions/aboutImages";

const initialState = {
  aboutImages: [],
  currentAboutImage: null,
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  reorderLoading: false,
};

const aboutImagesSlice = createSlice({
  name: "aboutImages",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentAboutImage: (state) => {
      state.currentAboutImage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAboutImages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAboutImages.fulfilled, (state, action) => {
        state.loading = false;
        state.aboutImages = action.payload.data || action.payload;
      })
      .addCase(getAllAboutImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(getAboutImageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAboutImageById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentAboutImage = action.payload;
      })
      .addCase(getAboutImageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(createAboutImage.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(createAboutImage.fulfilled, (state, action) => {
        state.createLoading = false;
        state.aboutImages.push(action.payload);
      })
      .addCase(createAboutImage.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateAboutImage.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateAboutImage.fulfilled, (state, action) => {
        state.updateLoading = false;
        const index = state.aboutImages.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.aboutImages[index] = action.payload;
        }
        if (state.currentAboutImage?.id === action.payload.id) {
          state.currentAboutImage = action.payload;
        }
      })
      .addCase(updateAboutImage.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteAboutImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAboutImage.fulfilled, (state, action) => {
        state.loading = false;
        state.aboutImages = state.aboutImages.filter(
          (item) => item.id !== action.payload
        );
        if (state.currentAboutImage?.id === action.payload) {
          state.currentAboutImage = null;
        }
      })
      .addCase(deleteAboutImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(reorderAboutImages.pending, (state) => {
        state.reorderLoading = true;
        state.error = null;
      })
      .addCase(reorderAboutImages.fulfilled, (state, action) => {
        state.reorderLoading = false;
        state.aboutImages = action.payload;
      })
      .addCase(reorderAboutImages.rejected, (state, action) => {
        state.reorderLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError, clearCurrentAboutImage } = aboutImagesSlice.actions;
export default aboutImagesSlice.reducer;
